module.exports = __webpack_public_path__ + "media/club_deals/current_opportunities_vertical_card2-1bd5b00a.webp";